import { Component, Input, OnInit } from '@angular/core';
import { Employee } from "../../core/models/employee.model";

@Component({
    selector: 'app-education-show',
    templateUrl: './education-show.component.html',
    styleUrls: ['./education-show.component.css']
})
export class EducationShowComponent implements OnInit {

    @Input()
    employee: Employee;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/verification-show/education-show/education-show.component.ts